import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type States = {
  accessToken: string | undefined;
  refreshToken: string | undefined;
  isAuthenticated: boolean;
  isLoading: boolean;
};

type Actions = {
  setIsLoading: (loadingState: boolean) => void;
  setAccessToken: (accessToken: string | undefined) => void;
  setRefreshToken: (refreshToken: string | undefined) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  clearTokens: () => void;
};

type AuthStore = States & Actions;

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      accessToken: undefined,
      refreshToken: undefined,
      isAuthenticated: false,
      isLoading: false,
      setIsLoading: (loadingState: boolean) => set({ isLoading: loadingState }),
      setAccessToken: (accessToken: string | undefined) => set({ accessToken }),
      setRefreshToken: (refreshToken: string | undefined) => set({ refreshToken }),
      setIsAuthenticated: (isAuthenticated: boolean) => set({ isAuthenticated }),
      setTokens: (accessToken: string, refreshToken: string) => {
        if (accessToken && refreshToken) {
          set({ accessToken, refreshToken, isAuthenticated: true });
        }
      },
      clearTokens: () => {
        const storage = window.sessionStorage;
        storage.removeItem('authentication-store');
        set({
          accessToken: undefined,
          refreshToken: undefined,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: 'authentication-store',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
